import React from "react";

interface DominoProps {
  pips: [number, number];
  rotation?: number; // 0, 90, 180, 270
  isSelected?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
  size?: number; // Size in pixels for each half of the domino
}

// Pip patterns for domino faces
const PIP_PATTERNS: Record<number, Array<[number, number]>> = {
  0: [],
  1: [[12, 12]],
  2: [
    [8, 8],
    [16, 16],
  ],
  3: [
    [6, 6],
    [12, 12],
    [18, 18],
  ],
  4: [
    [6, 6],
    [18, 6],
    [6, 18],
    [18, 18],
  ],
  5: [
    [6, 6],
    [18, 6],
    [12, 12],
    [6, 18],
    [18, 18],
  ],
  6: [
    [6, 5],
    [18, 5],
    [6, 12],
    [18, 12],
    [6, 19],
    [18, 19],
  ],
};

const PipPattern: React.FC<{ count: number }> = ({ count }) => (
  <svg viewBox="0 0 24 24" className="w-full h-full">
    {(PIP_PATTERNS[count] || []).map(([cx, cy], i) => (
      <circle key={i} cx={cx} cy={cy} r="1.5" fill="currentColor" />
    ))}
  </svg>
);

const Domino: React.FC<DominoProps> = ({
  pips,
  rotation = 0,
  isSelected = false,
  onClick,
  className = "",
  size = 56,
}) => {
  const [pip1, pip2] = pips;

  return (
    <div
      className={`inline-flex bg-white border-2 border-gray-800 rounded-lg shadow-md cursor-pointer transition-all duration-200 ${isSelected ? "ring-4 ring-blue-400 scale-105" : ""} ${className}`}
      onClick={onClick}
      style={{
        transform: `rotate(${rotation}deg)`,
        position: "relative",
        zIndex: isSelected ? 10 : 1,
      }}
    >
      <div className="border-r border-gray-800 p-1 text-gray-800" style={{ width: `${size}px`, height: `${size}px` }}>
        <PipPattern count={pip1} />
      </div>
      <div className="p-1 text-gray-800" style={{ width: `${size}px`, height: `${size}px` }}>
        <PipPattern count={pip2} />
      </div>
    </div>
  );
};

export default Domino;
